<template>
    <div class="mainContent">


    </div>
</template>

<script>

    export default {
        name: "mainContent",
    }
</script>

<style scoped>


</style>
